import { FileExtension } from '@/common/constants';
import { Signatures } from '@/components/elements/DropScan/dropScan.types';
import { getFileExtension } from '@/utils/modifiers/getFileExtension';

const isValidSignature = (file: File, signatures: string[]): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event: ProgressEvent<FileReader>) => {
      if (!event.target) {
        reject();
        return;
      }

      const result = event.target.result;
      if (!(result instanceof ArrayBuffer)) {
        reject();
        return;
      }

      const maxLength = Math.max(...signatures.map(sig => sig.length));
      const uint8Array = new Uint8Array(result.slice(0, maxLength));
      const firstBytes = new TextDecoder().decode(uint8Array);

      const isValid = signatures.some(signature => firstBytes.startsWith(signature));
      resolve(isValid);
    };

    reader.onerror = () => {
      reject();
    };

    reader.readAsArrayBuffer(file);
  });
};

export const isValidFilesSignature = async (files: File[]): Promise<boolean> => {
  const signatureChecks = files.map(async (file) => {
    const extension = getFileExtension(file);
    const signatures = Signatures?.[`.${extension}` as FileExtension];
    
    if (!signatures?.length) {
      return true;
    }

    return await isValidSignature(file, signatures);
  });

  const results = await Promise.all(signatureChecks);
  const invalidFile = files.find((_, index) => results[index]);
  return !!invalidFile;
};
